import ColumnText from "../molecules/ColumnText";
import { Fragment } from "react";
import { Empty } from "./Empty";

import { t } from "i18next";
import ColumnPersonInformationAvatar from "../molecules/ColumnPersonInformationAvatar";
import EllipsesMenuTableStock from "../molecules/EllipsesMenuTableStock";
import { TableLoader } from "../molecules/TableLoader";
import { Trash2Icon } from "lucide-react";

export type TableListStockStoreProps = {
  products: Array<any>;
  onAddStock: (product: any) => void;
  onDeleteStock: (product: any) => void;
  onCreate?: () => void;
  onEdit: (product: any) => void;
  onDeleteProduct: (product: any) => void;
  isLoading?: boolean;
};

const TableListStockStore: React.FC<TableListStockStoreProps> = ({
  isLoading,
  products,
  onAddStock,
  onDeleteStock,
  onCreate,
  onEdit,
  onDeleteProduct,
}) => {
  return (
    <div className="px-2 sm:px-4 lg:px-6 h-full overflow-hidden">
      <div className="flow-root mb-4 h-full">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 h-full">
          <div className="inline-block min-w-full px-3 py-2 align-middle sm:px-6 lg:px-8 h-full">
            {isLoading ? (
              <TableLoader columns={5} />
            ) : (
              <Fragment>
                {products.length === 0 ? (
                  <div className="pt-5">
                    <Empty
                      texto={t("store.views.message_no_product")}
                      onClick={onCreate}
                    />
                  </div>
                ) : (
                  <Fragment>
                    <div className="">
                      <table className="min-w-full divide-y divide-gray-300">
                        <thead>
                          <tr>
                            <th
                              scope="col"
                              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                            >
                              {t("store.views.form.name")}
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                            >
                              {t("store.views.form.reference")}
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                            >
                              {t("store.views.form.price")}
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                            >
                              {t("store.views.form.stock")}
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-3.5 text-sm text-center font-semibold text-gray-900"
                            >
                              {t("store.views.form.actions")}
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 bg-white">
                          {products.map((product) => (
                            <tr key={product.id}>
                              <ColumnPersonInformationAvatar
                                id={product.id}
                                name={product.name}
                                email={""}
                                image={product.img}
                                classNameImg="w-10 h-10"
                              />
                              <ColumnText
                                title={product.reference}
                                className="max-w-40 truncate"
                              />
                              <ColumnText
                                title={`${product.currency?.toUpperCase()} ${parseFloat(product.price).toFixed(2)}`}
                              />
                              <ColumnText title={product.amount} />
                              <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                                <div className="flex items-center gap-2 justify-end">
                                  <span
                                    className="text-primary-600 hover:text-primary-900 cursor-default"
                                    onClick={() => onEdit(product)}
                                  >
                                    {t("general.edit")}
                                    <span className="sr-only"></span>
                                  </span>
                                  <Trash2Icon
                                    className="text-red-600 hover:text-red-900 cursor-default"
                                    size={16}
                                    onClick={() => onDeleteProduct(product)}
                                  />
                                  <EllipsesMenuTableStock
                                    OnAddStock={() => onAddStock(product)}
                                    OnDeleteStock={() => onDeleteStock(product)}
                                  />
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Fragment>
                )}
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableListStockStore;
